import { Navigate, useLocation } from "react-router-dom";
import { SignIn } from "@clerk/react";
import { HERO_IMG } from "@/lib/brand";
import { PhoneLogin } from "@/components/auth/PhoneLogin";

function Shell({ children }) {
  return (
    <div className="grid min-h-[calc(100vh-4rem)] lg:grid-cols-2">
      <div className="relative hidden overflow-hidden lg:flex">
        <img src={HERO_IMG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A2E1D]/85 to-black/10" />
        <div className="relative mt-auto p-12 text-white">
          <p className="label-eyebrow !text-hc-gold">HooreCars.com</p>
          <h2 className="mt-3 max-w-md text-4xl font-bold tracking-tight">Your next road trip starts here.</h2>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-5 px-4 py-12" data-testid="auth-panel">{children}</div>
    </div>
  );
}

const hideSocial = { elements: { socialButtonsRoot: { display: "none" }, dividerRow: { display: "none" }, footerAction: { display: "none" } } };

export function SignInPage() {
  const { search } = useLocation();
  const ticket = new URLSearchParams(search).has("__clerk_ticket");
  return (
    <Shell>
      {ticket ? <SignIn routing="path" path="/sign-in" appearance={hideSocial} /> : (
        <>
          <PhoneLogin footer="New or returning — sign in and sign up both use your mobile number." />
          <p className="max-w-[400px] text-center text-xs text-hc-slate">By continuing you agree to our <a href="/legal/terms" className="underline">Terms</a> and <a href="/legal/privacy" className="underline">Privacy Policy</a>.</p>
        </>
      )}
    </Shell>
  );
}

export const SignUpPage = () => <Navigate to="/sign-in" replace />;

export const AdminSignInPage = () => (
  <div className="grid min-h-screen place-items-center bg-hc-cream px-4" data-testid="admin-signin-page">
    <SignIn routing="path" path="/admin/sign-in" fallbackRedirectUrl="/admin" appearance={hideSocial} />
  </div>
);
